/* Return null regardless of PropTypes */
import React from 'react';

export default function Null(props) {
    return null;
}